/* eslint-disable no-unused-expressions */
import React from 'react';
import TextField from '@mui/material/TextField';
import { debounce } from 'lodash';
import { FormControl } from '@mui/material';
import { makeStyles } from 'src/makeStyles';
import { FbAutocompleteSelect } from '../FbAutocompleteSelect';
import { style } from './style';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles()(theme => style(theme));

export const FBAutocompleteSelectFilter = ({
  filterType,
  options,
  getOptionName,
  isOptionEqualToValue,
  getOptions,
  onSelectValue,
  onClearValue,
  label,
  onOpen,
  onFocus,
  filterOptions,
  ...additionalProps
}) => {
  const { classes, cx } = useStyles();
  const { value: initialValue, onSearch, isMobile, optionDisplayAttribute, ...restOfTheProps } = additionalProps;

  const props = {
    'data-test-id': `${filterType}-filter`,
    onOpen: (event, setOptionsCallback) => {
      onOpen && onOpen(event, setOptionsCallback);
    },
    // eslint-disable-next-line no-shadow
    onChange: (event, selectedValue, reason) => {
      if (reason === 'selectOption') {
        onSelectValue(filterType, selectedValue);
      }
      if (reason === 'clear') {
        onClearValue(filterType, reason);
      }
    },
    onFocus: (event, setOptionsCallback) => {
      onFocus && onFocus(event, setOptionsCallback);
    },
    onSearch: debounce((keyword, setOptionsCallback) => {
      onSearch && onSearch(keyword?.toLowerCase(), setOptionsCallback);
    }, 100),
    isOptionEqualToValue,
    getOptionLabel: option => getOptionName(option),
    options,
    loading: false,
    forcePopupIcon: false,
    disablePortal: false,
    openOnFocus: true,
    selectOnFocus: true,
    debug: true,
    value: initialValue,
    filterOptions,
    optionDisplayAttribute,
    renderInput: params => <TextField {...params} label={label} variant="outlined" />,
    ...restOfTheProps,
  };

  return (
    <FormControl fullWidth className={cx(classes.field)}>
      <FbAutocompleteSelect
        {...props}
        classes={{
          root: classes.root,
          inputRoot: classes.inputRoot,
          clearIndicator: classes.clearIndicator,
          popper: isMobile ? classes.popper : cx(classes.popper, classes.popperDesktop),
          option: classes.option,
        }}
      />
    </FormControl>
  );
};
